import Breadcrumbs from "../Breadcrumbs";
import {useState, useContext} from "react";
import {GlobalContext, ReducerActionType} from "../../../GlobalReducer";
import {ReducerStateInterface} from "../../../interfaces/core/ReducerStateInterface";
import {POST_ADDRESS} from "../../../Config";


export default function Refund() {

		const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
		const [block, setBlock] = useState('')


	const getBreadcrumbs = () => {
		return [
			{
				icon: "ico-home-g",
				url: "/",
				isActive: true
			},
			{
				name: 'Возврат товара'
			}
		]
	}

	return (<main className="main-refund">
			<section className="text-page pt">
				<div className="container-fluid">
					<div className="row">
						<div className="col">
							<Breadcrumbs breadcrumbs={getBreadcrumbs()} />
						</div>
					</div>
					<div className="row text-page__wrap">
						<div className="col-lg-6 text-page__left f-exp">
							<h1 className="text-page__title">Возврат товара</h1>
							<blockquote>
								Теперь вы можете вернуть товар из интернет-магазина в любой фирменный розничный магазин BAON.
							</blockquote>
						</div>
						<div className="col-lg-6 text-page__right">
                            <div className="text-page__list">
                                <div className="text-page__list-block bd">
                                    <div className="text-page__col-wrap">
                                        <p>
                                            Если вы совершили покупку в розничном магазине BAON (независимо от того, был
                                            ли оформлен заказ через интернет-магазин или нет), оформить возврат товара
                                            необходимо в этом же магазине. Если покупка была совершена через
                                            интернет-магазин BAON.RU, то вы можете вернуть товар любым удобным способом:
                                        </p>
                                        <ul>
                                            <li>в фирменном магазине BAON</li>
                                            <li>по почте</li>
                                        </ul>
                                        <p>
                                            Возврат товара надлежащего качества* возможен в том случае, если сохранены
                                            его товарный вид, потребительские свойства, а также документы,
                                            подтверждающие факт и условия покупки указанного товара (товарный или
                                            кассовый чек). Выплата денежных средств осуществляется после того, как
                                            покупатель предоставит продавцу товар, подтверждающий его приобретение
                                            документ, заявление с указанием причины возврата и полные реквизиты
                                            банковского счета (см. ниже).
                                        </p>
                                        <p>
                                            * Возврату по данному основанию не подлежат непродовольственные товары
                                            надлежащего качества, предусмотренные Перечнем непродовольственных товаров
                                            (парфюмерно - косметические товары, швейные и трикотажные изделия (изделия
                                            швейные и трикотажные бельевые, изделия чулочно-носочные, текстильные товары
                                            (хлопчатобумажные, льняные, шелковые, шерстяные и синтетические ткани,
                                            товары из нетканых материалов типа тканей - ленты, тесьма, кружево и
                                            другие)) надлежащего качества, не подлежащих возврату или обмену на
                                            аналогичный товар других размера, формы, габарита, фасона, расцветки или
                                            комплектации, утвержденным Постановлением Правительства РФ от 19.01.98г. №
                                            55 (с изменениями от 20.10.98г., 02.10.99г., 06.02.2002г.)). Возврат товара
                                            ненадлежащего качества осуществляется в соответствии с условиями, описанными
                                            выше, перечисление денежных средств производится после товароведческой
                                            экспертизы.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
						</div>
                    <div className="row text-page__wrap mb">
                        <div className="col-lg-5 text-page__left f-exp">
                            <h5 className="f-exp">
                                Вы вправе отказаться от товара в течение 10 рабочих дней с момента получения (в период
                                проведения специальных акций указанные сроки могут быть увеличены). Для этого вам
                                необходимо:
                            </h5>
                        </div>
                        <div className="col-lg-1"></div>
						<div className="col-lg-6 text-page__right">
							<div className="text-page__list">
								<div className={"text-page__list-block information bd "  + (block === 't1' ? 'show' : '')}>
									<a className="information__link f-exp" href="/" onClick={(event) => {
										event.preventDefault()
										setBlock(block === 't1' ? '' : 't1')
									}}>
										<div className="circle">
											<i className="ico ico-file"/>
										</div>
										<p>Заполнить заявление на возврат</p>
										<i className="ico ico-chevron-down-b"/>
									</a>
									
									  {block === 't1' && <div className="information__collapse">
										<div className="text-page__col-wrap">
										<ul>
                                		<li>в личном кабинете перейдите в МОИ ЗАКАЗЫ или, если заказ был оформлен через оператора call-центра, перейдите по ссылке</li>
										<li>выберите заказ, по которому хотите сделать возврат товара</li>
										<li>нажмите на ОФОРМИТЬ ВОЗВРАТ</li>
										<li>заполните все поля и нажмите РАСПЕЧАТАТЬ</li>
										<li>отправьте на электронную почту vozvrat@baon.ru копию паспорта с указанием номера заказа (только для нерезидентов РФ).</li>
									</ul>
									<br />
									<p>Заполненное заявление автоматически отправится менеджеру по возвратам BAON, а также продублируется на вашу электронную почту</p>
										</div>
									</div>}
								</div>
							   <div className={"text-page__list-block information bd "  + (block === 't2' ? 'show' : '')}>
									  <a className="information__link f-exp" href="/" onClick={(event) => {
										event.preventDefault()
										setBlock(block === 't2' ? '' : 't2')
									}}>
										<div className="circle">
											<i className="ico ico-box"/>
										</div>
										<p>Передать товар с приложенным заявлением о возврате любым удобным способом</p>
										<i className="ico ico-chevron-down-b"/>
									</a>
									{block === 't2' && <div className="information__collapse">
                                        <div className="text-page__col-wrap">
                                            <p>
                                                При возврате в <u>ФИРМЕННЫЙ МАГАЗИН</u> - заполните заявление на
                                                возврат. После заполнения <u>заявления</u> распечатайте его либо
                                                сохраните скриншот или фото. Товар передайте сотруднику розничного
                                                магазина, назвав номер электронного заявления (заполнение заявления в
                                                рукописном виде в фирменном магазине не производится).
                                            </p>
                                            <p>
                                                При возврате ПОЧТОЙ РОССИИ-отправляете вещи самостоятельно через
                                                отделение почты. Пришлите трек-номер или иной идентификатор для
                                                отслеживания возвращаемого товара на адрес эл. почты vozvrat@baon.ru,
                                                чтобы мы могли оперативно его получить.
                                            </p>
                                            <p>
                                                Адрес для отправки посылок Почтой России: {POST_ADDRESS}.
                                            </p>
                                            <p>
                                                Обратите внимание: расходы по пересылке товара покупатель берёт на себя.
                                                В том случае, если вы возвращаете товар по причине брака Почтой России,
                                                расходы будут компенсированы (при выборе других транспортных компаний
                                                стоимость обратной пересылки не компенсируется.) Сохраните квитанцию об
                                                оплате почтовых услуг и пришлите скан/фото на e-mail &nbsp;
                                                <a href="mailto:vozvrat@baon.ru">vozvrat@baon.ru</a>.
                                            </p>
                                        </div>
									</div>}
								</div>
							   <div className={"text-page__list-block information bd "  + (block === 't3' ? 'show' : '')}>
									  <a className="information__link f-exp" href="/" onClick={(event) => {
										event.preventDefault()
										setBlock(block === 't3' ? '' : 't3')
									}}>
										<div className="circle">
											<i className="ico ico-clock"/>
										</div>
										<p>Ожидать перевода денежных средств</p>
										<i className="ico ico-chevron-down-b"/>
									</a>
									{block === 't3' && <div className="information__collapse">
                                        <div className="text-page__col-wrap">
                                            <p>
                                                Денежные средства переводятся в течение 10 рабочих дней с момента
                                                фактического получения товара, подлежащего возврату. Обратите внимание:
                                                если вы оплачивали заказ банковской картой, то возврат денежных средств
                                                должен быть произведён на неё же.
                                            </p>
                                        </div>
									</div>}
								</div>
							</div>
						</div>
					</div>
					<div className="row text-page__banners">
						<div className="col-lg-6">
							<div className="text-page__banner">
								<picture>
									<source
										srcSet="img/text-page-banner-1.jpg"
										media="(max-width: 992px)"
									/>
									<img src="img/text-page-banner-1.jpg" alt=""/>
								</picture>
								<h2 className="f-exp">Магазины</h2>
								<p>
									Найти ближайший магазин Baon
									<br/> в России
								</p>
								<a className="btn btn-primary" href="/shops">
									Найти магазин
								</a>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="text-page__banner">
								<picture>
									<source
										srcSet="img/text-page-banner-2.jpg"
										media="(max-width: 992px)"
									/>
									<img src="img/text-page-banner-2.jpg" alt=""/>
								</picture>
								<h2 className="f-exp">Есть вопрос?</h2>
								<p>
									Звоните 8 (800) 500-73-17 (звонок по России
									<br/> бесплатный) или задайте вопрос на сайте
								</p>
								<button className="btn btn-primary" onClick={(event) => {
									event.preventDefault()
									dispatch({type: ReducerActionType.TOGGLE_QUESTION_POPUP})
								}}>
									Подробнее
								</button>
							</div>
						</div>
					</div>
				</div>
			</section>

		</main>
	)
}